import './nav.scss';

import angular from 'angular';

import commonModule from '../../common';
import portalShellModule from 'portal/shell';

import shopNavComponent from './shopNav.component';
import navShoppingCartComponent from './navShoppingCart.component';
import navCheckoutComponent from './navCheckout.component';

export default angular.module('fp:customerportal:shop:shell:nav', [
    commonModule.name,
    portalShellModule.name
])
.component('fpShopNav', shopNavComponent)
.component('fpNavShoppingCart', navShoppingCartComponent)
.component('fpNavCheckout', navCheckoutComponent);